import { render, staticRenderFns } from "./MyQuotes.vue?vue&type=template&id=57f7779c&scoped=true&"
import script from "./MyQuotes.vue?vue&type=script&lang=js&"
export * from "./MyQuotes.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotes.vue?vue&type=style&index=0&id=57f7779c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7779c",
  null
  
)

export default component.exports